<template>
  <div>
    <el-card style="margin: auto;">
      <div slot="header" class="clearfix">
        <div style="float: left">
          <span style="font-weight:800;margin:5px">{{ name }} 的 pod</span>
          <el-tag type="primary" style="margin:5px" size="mini">集群：{{ cluster }}</el-tag>
          <el-tag type="danger" style="margin:5px" size="mini">命名空间：{{ namespace }}</el-tag>
        </div>
      </div>
      <el-table :data="pods" border>
        <el-table-column label="名称" prop="metadata.name" width="250"></el-table-column>
        <el-table-column label="命名空间" prop="metadata.namespace"></el-table-column>
        <el-table-column label="所在节点" prop="spec.nodeName"></el-table-column>
        <el-table-column label="节点 IP" prop="status.hostIP"></el-table-column>
        <el-table-column label="Pod IP" prop="status.podIP"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="record">
            <el-tag
              type="success"
              size="mini"
              effect="dark"
              v-if="record.row.status.phase === 'Running'"
            >Running</el-tag>
            <el-tag
              type="danger"
              size="mini"
              effect="dark"
              v-else-if="record.row.status.phase === 'Failed'"
            >Failed</el-tag>
            <el-tag
              type="warning"
              size="mini"
              effect="dark"
              v-else-if="record.row.status.phase === 'Pending'"
            >Pending</el-tag>
            <el-tag
              type="primary"
              size="mini"
              effect="dark"
              v-else-if="record.row.status.phase === 'Sucess'"
            >Sucess</el-tag>
            <el-tag size="mini" v-else>Unknown</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="record">
            <el-button
              size="mini"
              type="primary"
              @click="show_pod_profile(record.row.metadata.name)"
            >详情</el-button>
            <el-button
              size="mini"
              type="warning"
              @click="show_pod_container(record.row.metadata.name)"
            >容器</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 15px;">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="page_size"
          @current-change="get_pods"
        ></el-pagination>
      </div>

      <el-dialog :visible.sync="visible" title="详情" width="50%">
        <editor
          v-model="pod_yaml"
          @init="editorInit"
          lang="yaml"
          theme="gruvbox"
          height="700"
          :options="{ readOnly: true }"
        ></editor>
      </el-dialog>

      <el-dialog :visible.sync="container_visible" title="容器" width="50%">
        <el-table :data="pod.spec.containers">
          <el-table-column prop="name"></el-table-column>
          <el-table-column width="180">
            <template slot-scope="item">
              <el-link type="primary" @click="get_log(pod.metadata.name, item.row.name)" style="margin-right:5px">获取日志</el-link>
              <el-link type="danger" @click="get_terminal(pod.metadata.name, item.row.name)">终端</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>

    <el-row style="margin-top:15px" :gutter="20">
      <el-col :span="12">
        <el-card style="margin: auto">
          <div slot="header" class="clearfix">
            <span style="font-weight:800;margin:5px;float:left">apk 文件列表</span>
          </div>
          <el-collapse>
            <el-collapse-item
              v-for="i in apklist"
              :key="i.package"
              :title="i.package"
              :name="i.package"
            >
              <el-alert :title="'hash: ' + i.hash" type="info" effect="dark" :closable="false"></el-alert>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin: auto">
          <div slot="header" class="clearfix">
            <span style="font-weight:800;margin:5px;float:left">spec 源文件</span>
          </div>
          <editor
            v-model="android_yaml"
            @init="editorInit"
            lang="yaml"
            theme="gruvbox"
            height="700"
            :options="{ readOnly: true }"
          ></editor>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import yaml from "js-yaml";

export default {
  data() {
    return {
      aceEditor: null,
      page_size: 0,
      total: 0,
      android: {},
      apklist: [],
      android_yaml: "",
      pods: [],
      pod: {
        spec: {
          containers: [],
        },
      },
      pod_yaml: "",
      cluster: "",
      namespace: "",
      visible: false,
      container_visible: false,
      name: "",
      xterm: null,
    };
  },
  components: {
    editor: require("vue2-ace-editor"),
  },
  created() {
    this.page_size = this.config.pageSize;
    this.get_pods(1);
    this.cluster = this.$route.params.cluster;
    this.namespace = this.$route.params.namespace;
    this.name = this.$route.params.name;
    this.get_android();
  },
  methods: {
    get_android() {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/androids/" +
            _this.$route.params.name +
            "?cluster=" +
            _this.$route.params.cluster +
            "&namespace=" +
            _this.$route.params.namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取安卓信息失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            _this.android = res.data.data;
            console.log(_this.android);
            _this.android_yaml = yaml.dump(_this.android);
            console.log(_this.android.spec.template.androidConfig.apklist);
            const l = _this.android.spec.template.androidConfig.apklist;
            for (let i = 0; i < l.length; i++) {
              let m = {};
              let apk = l[i].split("@");
              m["package"] = apk[0];
              m["hash"] = apk[1];
              _this.apklist.push(m);
            }
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取安卓信息失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
    },
    show_pod_profile(name) {
      this.get_pod(name);
      this.visible = true;
    },
    show_pod_container(name) {
      this.get_pod(name);
      this.container_visible = true;
    },
    get_pod(name) {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/pods/" +
            name +
            "?cluster=" +
            _this.$route.params.cluster +
            "&namespace=" +
            _this.$route.params.namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取pod信息失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            console.log(res.data.data);
            _this.pod = res.data.data;
            _this.pod_yaml = yaml.dump(_this.pod);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取pod信息失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
    },
    get_log(name, container) {
      // console.log(name, container);
      this.$router.push({
        path: `/log/${this.cluster}/${this.namespace}/${name}?container=${container}`,
      });
    },
    get_terminal(name, container) {
      this.$router.push({
        path: `/terminal/${this.cluster}/${this.namespace}/${name}?container=${container}`,
      });
    },
    get_pods(page) {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/pods?name=" +
            _this.$route.params.name +
            "&currentPage=" +
            page +
            "&pageSize=" +
            this.page_size +
            "&cluster=" +
            _this.$route.params.cluster +
            "&namespace=" +
            _this.$route.params.namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取pod列表失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            console.log(res.data.data);
            _this.pods = res.data.data;
            _this.total = res.data.page.totalCount;
            console.log(_this.pods);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取pod列表失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
    },
    editorInit: function () {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/theme/gruvbox");
    },
  },
};
</script>
